<template>
  <div class="manage-section">
    <div class="current-title">图斑管理</div>
    <div class="search-wrap">
      <el-input v-model="search.keyword" placeholder="请输入名称/野外编号" style="width: 200px; margin-right: 10px;"></el-input>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button type="success" @click="openAdd">新建</el-button>
      <el-button type="warning" @click="openImport">导入</el-button>
      <el-button @click="downloadTemplate">下载模板</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="图斑ID" width="80"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="fieldNo" label="野外编号"></el-table-column>
        <el-table-column prop="area" label="面积(㎡)"></el-table-column>
        <el-table-column prop="township" label="乡镇/街道"></el-table-column>
        <el-table-column prop="vegetationSurvivalRate" label="复绿植被成活率(%)"></el-table-column>
        <el-table-column prop="vegetationSurvivalCount" label="复绿植被成活数(株)"></el-table-column>
        <el-table-column prop="soilQualityRate" label="土壤质量达标率(%)"></el-table-column>
        <el-table-column prop="waterQualityRate" label="水量质量达标率(%)"></el-table-column>
        <el-table-column prop="vegetationCoverage" label="植被覆盖率(%)"></el-table-column>
        <el-table-column prop="repairArea" label="修复面积(㎡)"></el-table-column>
        <el-table-column prop="latestStageYear" label="阶段年份"></el-table-column>
        <el-table-column prop="latestStageOrder" label="第几阶段"></el-table-column>
        <el-table-column prop="latestStageStatus" label="阶段状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.latestStageStatus == 1" type="success" size="mini">已完结</el-tag>
            <el-tag v-else-if="scope.row.latestStageStatus == 0" type="warning" size="mini">进行中</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column prop="createByName" label="创建人"></el-table-column>
        <el-table-column prop="updateByName" label="修改人"></el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="goDetail(scope.row)">详情</el-button>
            <el-button size="mini" @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pager-wrap">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="search.pageIndex"
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>

    <add-or-edit-spot :visible.sync="dialogVisible" :data="currentRow" @success="getList" />

    <el-dialog title="导入图斑" :visible.sync="importVisible" width="400px">
      <el-upload
        action=""
        :auto-upload="false"
        :on-change="handleFileChange"
        :limit="1"
        accept=".xls,.xlsx"
      >
        <el-button size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip">支持 .xls / .xlsx，若野外编号相同则覆盖更新</div>
      </el-upload>
      <span slot="footer">
        <el-button @click="importVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmImport">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import addOrEditSpot from "./components/addOrEditSpot.vue";
import config from "@/utils/config.js";

export default {
  components: { addOrEditSpot },
  data() {
    return {
      search: {
        keyword: "",
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      totalCount: 0,
      dialogVisible: false,
      currentRow: null,
      importVisible: false,
      importFile: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$apis.get("/admin/spot/page", this.search).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list || [];
          this.totalCount = res.data.data.totalCount || 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getList();
    },
    indexMethod(index) {
      return (this.search.pageIndex - 1) * this.search.pageSize + index + 1;
    },
    openAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    goDetail(row) {
      this.$router.push({ path: "/spotDetail", query: { spotId: row.id } });
    },
    handleDelete(row) {
      this.$confirm("确认删除该图斑？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/spot/delete", { id: row.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    openImport() {
      this.importVisible = true;
      this.importFile = null;
    },
    handleFileChange(file) {
      this.importFile = file.raw;
    },
    confirmImport() {
      if (!this.importFile) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importFile);
      this.$apis.upload("/admin/spot/import", formData).then(res => {
        if (res.data.code == 200) {
          this.$message.success("导入成功");
          this.importVisible = false;
          this.getList();
        } else {
          this.$message.error(res.data.msg || "导入失败");
        }
      });
    },
    downloadTemplate() {
      const url = config.baseUrl() + "/admin/spot/template";
      const token = localStorage.getItem("adminToken") || "";
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.setRequestHeader("adminToken", token);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: "application/vnd.ms-excel" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "图斑导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.$message.error("下载模板失败");
        }
      };
      xhr.send();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/spotManage.vue